// src/redux/slices/leaveSlice.js
import { createSlice } from "@reduxjs/toolkit";

const leaveSlice = createSlice({
  name: "leave",
  initialState: {
    entries: [],
    selectedLeave: null
  },
  reducers: {
    saveLeave: (state, action) => {
      state.entries.push(action.payload);
    },
    viewLeave: (state, action) => {
      state.selectedLeave = action.payload;
    },
    clearLeaveView: (state) => {
      state.selectedLeave = null;
    }
  }
});

export const { saveLeave, viewLeave, clearLeaveView } = leaveSlice.actions;
export default leaveSlice.reducer;
